import { isClickInsideElement } from '@/utils'
import { useMessageAtom } from '@pages/MesperyIM/store/message'

import AddGroupMembers from './AddGroupMembers'
import { ChatPanelContainer } from './ChatPanelContainer'
import { ChatPanelHeader } from './ChatPanelHeader'
import { ChatPanelInput } from './ChatPanelInput'
import { ChatRecords } from './ChatRecords'
import DropGroupMembers from './DropGroupMembers'
import { GroupManage } from './GroupManage'
import styles from '../message.module.less'

export const Chatbox = () => {
  const {
    groupManageVisible,
    chatRecordsVisible,
    setGroupManage,
    showAddGroupMembers,
    showDropGroupMembers
  } = useMessageAtom()

  const onClickPanel = (event: React.MouseEvent<HTMLDivElement>) => {
    const targetElement = document.getElementById('groupManageEle')
    if (targetElement && isClickInsideElement(targetElement, event)) {
      // console.log('点击发生在目标元素内部')
      return
    } else if (groupManageVisible) {
      setGroupManage(false)
    }
  }

  return (
    <div className={styles.ChatboxModal}>
      <div className="chats-panel" onClick={onClickPanel}>
        {/* 头部栏 */}
        <ChatPanelHeader />

        {/* 消息框 */}
        <ChatPanelContainer />

        {/* 输入框 */}
        <ChatPanelInput />

        {/* 群管理 */}
        {groupManageVisible ? <GroupManage /> : null}
      </div>
      {/* 聊天记录 */}
      {chatRecordsVisible && <ChatRecords />}

      {showAddGroupMembers ? <AddGroupMembers /> : null}

      {showDropGroupMembers ? <DropGroupMembers /> : null}
    </div>
  )
}
